<template>
  <div id="header_area">
    <div id="top_area">
      <!--  左侧区域  -->
      <div id="top_left">
        <!--        <a href="https://neverland.ivymobile.com/"><img src="@/assets/imagine/topup/icon.png" alt="top-logo"></a>-->
        <a href="/"><img src="@/assets/imagine/topup/icon.png" alt="top-logo"></a>
        <div class="line"></div>
        <span class="topTitle title" style="cursor: default;">{{ $t('home.center') }}</span>
      </div>

      <!--  右侧区域  -->
      <div id="top_right">
        <div class="add_desktop" ref="addDesktopBtn">
          <svg v-if="isMobile" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.41125 1.58545C3.30669 1.58545 2.41125 2.48088 2.41125 3.58545V17.4146C2.41125 18.5192 3.30669 19.4146 4.41126 19.4146H12.6194C13.724 19.4146 14.6194 18.5192 14.6194 17.4146V3.58545C14.6194 2.48088 13.724 1.58545 12.6194 1.58545H4.41125ZM6.63865 16.4979C6.17841 16.4979 5.80532 16.871 5.80532 17.3312C5.80532 17.7914 6.17841 18.1645 6.63865 18.1645H10.392C10.8523 18.1645 11.2254 17.7914 11.2254 17.3312C11.2254 16.871 10.8523 16.4979 10.392 16.4979H6.63865Z" fill="white"></path><rect x="10.1194" y="5.58337" width="9" height="9" rx="2.75" fill="white"></rect><rect x="10.1194" y="5.58337" width="9" height="9" rx="2.75" stroke="#557BE1" stroke-width="1.5"></rect><rect x="12.1194" y="9.33325" width="5" height="1.5" rx="0.75" fill="#557BE1"></rect><rect x="15.3694" y="7.58337" width="5" height="1.5" rx="0.75" transform="rotate(90 15.3694 7.58337)" fill="#557BE1"></rect></svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21" fill="none"><rect x="0.600098" y="0.141357" width="21.9131" height="13.9685" rx="2" fill="white"></rect><rect x="9.85934" y="10.6349" width="3.39445" height="9.05187" fill="white"></rect><rect x="18.2684" y="17.464" width="3.39445" height="13.4234" rx="1.69723" transform="rotate(90 18.2684 17.464)" fill="white"></rect><rect x="7.55661" y="6.12549" width="8" height="2" rx="1" fill="#557BE1"></rect><rect x="12.5566" y="3.12537" width="8" height="2" rx="1" transform="rotate(90 12.5566 3.12537)" fill="#557BE1"></rect></svg>

          <!--          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21" fill="none"><rect x="0.600098" y="0.141357" width="21.9131" height="13.9685" rx="2" fill="white"></rect><rect x="9.85934" y="10.6349" width="3.39445" height="9.05187" fill="white"></rect><rect x="18.2684" y="17.464" width="3.39445" height="13.4234" rx="1.69723" transform="rotate(90 18.2684 17.464)" fill="white"></rect><rect x="7.55661" y="6.12549" width="8" height="2" rx="1" fill="#557BE1"></rect><rect x="12.5566" y="3.12537" width="8" height="2" rx="1" transform="rotate(90 12.5566 3.12537)" fill="#557BE1"></rect></svg>-->

          <div class="title menu_title">{{ $t('home.saveTo') }}</div>
        </div>
        <div id="lang" @mouseenter="langListShow" @mouseleave="langListShow(false)">
          <div class="lang_title" @click="langListShow(true)">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 25 25" fill="none"><path d="M12.5566 7.27966L14.1132 9.73485L16.9293 10.4566L15.0753 12.6957L15.2591 15.5969L12.5566 14.5256L9.8542 15.5969L10.038 12.6957L8.184 10.4566L11 9.73485L12.5566 7.27966Z" fill="#557BE1" stroke="#557BE1" stroke-width="2" stroke-linejoin="round"></path><path d="M22.873 12.5C22.873 18.1976 18.2542 22.8164 12.5566 22.8164C6.85905 22.8164 2.24023 18.1976 2.24023 12.5C2.24023 6.80241 6.85905 2.18359 12.5566 2.18359C18.2542 2.18359 22.873 6.80241 22.873 12.5Z" fill="#557BE1"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12.5566 21.5269C17.542 21.5269 21.5835 17.4854 21.5835 12.5C21.5835 7.51461 17.542 3.47314 12.5566 3.47314C7.57125 3.47314 3.52979 7.51461 3.52979 12.5C3.52979 17.4854 7.57125 21.5269 12.5566 21.5269ZM12.5566 22.8164C18.2542 22.8164 22.873 18.1976 22.873 12.5C22.873 6.80241 18.2542 2.18359 12.5566 2.18359C6.85905 2.18359 2.24023 6.80241 2.24023 12.5C2.24023 18.1976 6.85905 22.8164 12.5566 22.8164Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M15.2563 3.06182C14.656 3.95298 13.3244 5.81173 12.8006 6.11746C12.1457 6.49963 10.5086 8.68247 11.2726 8.95533C11.8838 9.17361 12.9825 9.26456 13.4555 9.28275C13.1462 10.1013 12.5822 11.8258 12.8006 12.175C12.903 12.3389 12.5209 12.249 11.9805 12.1218C11.0815 11.9102 9.74448 11.5956 9.47181 12.175C9.41476 12.2963 9.35211 12.4156 9.29057 12.5329C8.88121 13.3129 8.52079 13.9997 10.1812 14.5216C12.0911 15.1219 15.6382 16.5407 14.2194 19.2147C13.4008 20.7575 13.2521 21.7875 13.3147 22.3579C13.1954 22.3669 13.0756 22.3739 12.9552 22.3786L11.2726 20.9064C10.9453 19.9787 10.1267 18.1342 9.47181 18.1778C8.90961 18.2153 8.7335 17.352 8.58996 16.6484C8.52448 16.3274 8.46578 16.0397 8.38031 15.8858C8.15181 15.4745 7.46407 15.1781 6.89397 14.9323L6.89396 14.9323L6.8939 14.9323L6.89375 14.9322C6.78316 14.8845 6.677 14.8388 6.57948 14.7944C6.09926 14.5761 5.36076 13.5393 5.05154 13.0482L5.54273 10.5379H3.41446L3.01503 9.90175C4.15593 5.70198 7.9956 2.6134 12.5566 2.6134C13.4971 2.6134 14.4069 2.74473 15.2688 2.99004L15.2563 3.06182ZM21.134 7.58004C20.8766 8.24624 19.9716 9.03939 19.0851 9.81633C18.0867 10.6913 17.1118 11.5457 17.1118 12.175C17.1118 13.2493 17.1118 15.2418 21.1405 17.4086C21.9693 15.9623 22.4432 14.2865 22.4432 12.5C22.4432 11.3481 22.2462 10.2422 21.8841 9.21422L21.3041 7.88847C21.2492 7.78454 21.1925 7.68173 21.134 7.58004Z" fill="white"></path></svg>
            <div class="title menu_title">{{ $t('home.langNow') }}</div>
          </div>
          <div class="langContent" style="display: none;" ref="langBox" >
            <ul class="langAreaList">
              <li class="langItem"
                @click="changeLang(langs[i], i)"
                  v-for="langName, i in langList"
                  :key="langs[i]"> {{langName}} </li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// import { resolveUrl } from 'vue';
import {changeLanguage} from '../language'
export default {
  name: "HeaderMenu",
  data() {
    return {
      langList: ["English", "日本語", "한국어", "Deutsch", "Français", "Español", "Português", "Indonesia", "Русский язык", 'แบบไทย', 'Melayu', "Nederlands", 'українська', 'Italiano', 'Polski', 'Svenska', 'Norsk', 'Dansk', "繁體中文", "简体中文"],  // 支持的语言类型
      langs: ['en', 'ja', 'ko', 'de', 'fr', 'es', 'pt', 'id', 'ru', 'th', 'ms', 'nl', 'uk', 'it', 'pl', 'sv', 'nn', 'da', 'tw', 'zh'],
      currentLang: "English",   // 默认的语言类型
      isMobile: false,    // 以屏幕宽度区分是否是移动端
    }
  },
  created() {
    this.handleResize();      // 初始状态自适应屏幕大小
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    let langSet = localStorage.getItem("selectedLang")
    if(langSet !== undefined){
      let _langSet = JSON.parse(langSet)
      let lang = _langSet.lang;
      let index = _langSet.index;
      this.currentLang = this.langList[index];
      this.changeLang(lang, index)
    }
  },
  
  methods: {
    // 控制是否显示切换语言列表
    langListShow(isShow=true) {
      this.$refs.langBox.style.display = isShow?"flex":"none";
    },

    // 屏幕宽度改变的时候
    handleResize() {
      this.isMobile = window.innerWidth<=800;
    },

    async changeLang(lang, idx){
      const result = await changeLanguage(lang);
      if (result){
        this.currentLang = this.langList[idx];
        this.$i18n.locale = lang;
        this.langListShow(false);
        let langSet = {
          lang: lang,
          index: idx
        }
        localStorage.setItem("selectedLang", JSON.stringify(langSet));
      }
    }
  }
}
</script>

<style scoped lang="scss">
  #header_area {
    height: 58px;
    //padding: 8px 0;
    //overflow: hidden;
    background-color: #557be1;

    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;

    @media screen and (min-width: 1100px) { #top_area { width: 1100px; } }
    @media screen and (max-width: 1099.9px) { #top_area { width: 1100px; padding: 0 6px 0 15px;} }
    #top_area {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      height: 100%;
      #top_left {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        text-align: center;
        img {
          height: 48px;
          border-radius: 6px;
        }
        .line {
          width: 1px;
          height: 30px;
          background-color: #fff;
          margin: 0 14px;
        }
        .topTitle {
          font-weight: 600;
          border: none;
        }
      }

      #top_right {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        .add_desktop, .lang_title {
          padding: 10px 18px;
          height: 21px;

          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          border-radius: 25px;
          cursor: pointer;
          margin-left: 5px;
          svg {
            margin-right: 5px;
          }
        }
        #lang {
          position: relative;
          height: 100%;
          display: flex;
          align-items: center;
        }
        .langContent {
          display: flex;
          flex-flow: column nowrap;
          position: absolute;
          right: 0;
          top: 58px;
          background: #fff;
          box-shadow: 0 4px 8px 0 rgba(0,0,0,.15);
          border-radius: 1.2rem;
          z-index: 20;
          ul.langAreaList {
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            padding: 0 16px;
            .langItem {
              width: 86px;
              text-align: center;
              color: #666;
              font-size: small;
              line-height: 2.2rem;
              font-weight: 400;
              border-bottom: .1rem solid #eee;
            }
            .langItem:last-child {
              border-bottom: none;
            }
            .langItem:hover {
              color: #4d6fcb;
              cursor: pointer;
            }
          }
          .langContent li {
            list-style: none;
          }
        }
        .add_desktop:hover, .lang_title:hover {
          background-color: #4d6fcb;
        }
      }
    }
  }

  .title {
    color: #fff;
    font-family: Roboto, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, PingFang SC, Noto Sans, Microsoft Yahei, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  }



  /*  设置属于移动端的样式  */
  @media screen and (max-width: 800px) {
    @keyframes shake-and-stay {
      0%,20% { transform: rotate(0deg); }
      15%,5% { transform: rotate(-25deg); }
      10% { transform: rotate(25deg); }
      60%,to { transform: rotate(0deg); }
    }
    #header_area {
      height: 40px;
      #top_area {
        font-size: 12px;
        .menu_title {
          display: none;
        }
        #top_left {
          .line {
            display: none;
          }
          img {
            height: 32px;
            margin-right: 15px;
            border-radius: 6px;
          }
          .add_desktop, .lang_title {

          }
        }
        #top_right {
          .add_desktop {
            padding: 5px 3px;
            svg {
              animation: shake-and-stay 5s linear infinite;
              top: -7px;
              right: -4px;
            }
          }
          .lang_title {
            padding: 5px 3px!important;
          }
        }
      }
    }

    .langContent {
      top: 40px!important;
    }
  }
</style>